import { Spinner } from "../../shared/ui/index.js";
import { WallFeed } from "../wall/WallFeed.js";
import { useEventQr } from "./events.api.js";
import type { ThemeId } from "@smartvow/shared";

/** Vue organisateur du mur des invités : le même fil, en lecture seule. */
export function OwnerWallPanel({ eventId, theme }: { eventId: string; theme: ThemeId }) {
  const qr = useEventQr(eventId);

  if (!qr.data) {
    return (
      <div className="mt-6 flex justify-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div data-theme={theme}>
      <WallFeed eventId={eventId} token={qr.data.token} email="" readOnly embedded />
    </div>
  );
}
